//* Components
import Text from 'components/common/Text'
import Container from 'components/common/Container'
import DangerDescription from 'components/common/DangerDescription'
import LinearSlider from 'components/common/LinearSlider'

//* Style
import LinearSliderGalleryStyle from './style'

const LinearSliderGallery = ({ bgColor, title, descriptions, items, first }) => {
    return (
        <LinearSliderGalleryStyle>
            <Container first={first} section full>
                <div className={`bg${bgColor} content-wrap`}>
                    {title && <Container>
                        <Text tag={'h3'} className={'font-ping-bolder title'} text={title} />
                    </Container>}
                    {descriptions && <DangerDescription descriptions={descriptions} />}
                </div>
                <LinearSlider items={items} />
            </Container>
        </LinearSliderGalleryStyle>
    )
}

export default LinearSliderGallery
